import { ICompletenessData } from 'legacy/lut/features/partner360/completeness'

import Logger from 'core/utils/Logger'
import { ICompletenessInfo } from 'partner360/entities/partnerCompleteness'

export const mapJSONToCompleteness = (rawData: string): ICompletenessData[] => {
  try {
    const parsedData: ICompletenessInfo[] = JSON.parse(rawData || '[]')

    return parsedData.map<ICompletenessData>((it) => ({
      profile: it.Profile,
      total: it.Total,

      assortment: it.Assortment,
      basicInfo: it.BasicInfo,
      contacts: it.Contacts,
      swot: it.Swot,
      deviceInfoPrint: it.DeviceInfoPrint,
      deviceInfo: it.DeviceInfo,
      shareOfBusiness: it.ShareOfBusiness,
      marketInfo: it.MarketInfo,
      solutions: it.Solutions,
      finSobPlan: it.FinSobPlan,
      initiativesPlan: it.InitiativesPlan,
      planning: it.Planning,
      actionsPlan: it.ActionsPlan,
      masterDealer: it.MasterDealer,
      inventory: it.Inventory,
      creditStatusInfo: it.CreditStatusInfo,
      mps: it.MPS,
      printServices: it.PrintServices,
      poly: it.Poly,
      personalSystemsServices: it.PSServices,
      mif: it.MIF,
      mpsSubs: it.MPSSubs,
      rooms: it.Rooms,
      aipc: it.AIPC,

      blockMessage: it.BlockMessage,
      warningMessage: it.WarningMessage,

      initiativesPlanMessage: it.InitiativesPlanMessage,
      initiativesPlanWarning: it.InitiativesPlanWarning,
      acknowledgementWarning: it.AcknowledgementWarning,
    }))
  } catch (e) {
    Logger.error('Failed to parse completeness', e)
    return []
  }
}
